import React, { useState } from 'react';
import { priceFormatterV3 } from '../../../settings/themeSettings';
import SectionHeader from '../components/SectionHeader';

const AnalyseTemporelle = ({ dashboardData, startDate, endDate, setStartDate, setEndDate }) => {
    const [viewMode, setViewMode] = useState('monthly'); // 'monthly', 'quarterly', 'yearly'

    // Mock data for analysis - in a real app, this would come from props or processed data
    const analysisData = [
        { period: 'Jan', tourism: 125000, ticketing: 45000, total: 170000, lastYear: 160000 },
        { period: 'Feb', tourism: 110000, ticketing: 42000, total: 152000, lastYear: 145000 },
        { period: 'Mar', tourism: 135000, ticketing: 48000, total: 183000, lastYear: 190000 },
        { period: 'Apr', tourism: 145000, ticketing: 51000, total: 196000, lastYear: 180000 },
        { period: 'May', tourism: 160000, ticketing: 55000, total: 215000, lastYear: 200000 },
    ];

    return (
        <div className="analysis-section">
            <SectionHeader
                title="📅 ANALYSE TEMPORELLE"
                pdfData={analysisData.map(d => ({
                    metrique: d.period,
                    montant: d.total,
                    pourcentage: viewMode,
                    marge: d.total - d.lastYear
                }))}
                pdfFilename="analyse-temporelle.pdf"
                pdfTitle={`Analyse Temporelle (${viewMode})`}
                pdfTableHeaders={["Période", "Total N", "Type Vue", "Variation"]}
            />

            <div className="dashboard-filters" style={{ margin: '0 0 20px 0' }}>
                <div className="section-selector" style={{ margin: 0, padding: '10px', boxShadow: 'none', background: 'transparent', border: 'none' }}>
                    <div className="selector-buttons" style={{ justifyContent: 'flex-start', gap: '10px' }}>
                        <button
                            className={`section-btn ${viewMode === 'monthly' ? 'active' : ''}`}
                            onClick={() => setViewMode('monthly')}
                            style={{ minWidth: 'auto', minHeight: 'auto', padding: '10px 20px' }}
                        >
                            <span className="section-name">Mensuel</span>
                        </button>
                        <button
                            className={`section-btn ${viewMode === 'quarterly' ? 'active' : ''}`}
                            onClick={() => setViewMode('quarterly')}
                            style={{ minWidth: 'auto', minHeight: 'auto', padding: '10px 20px' }}
                        >
                            <span className="section-name">Trimestriel</span>
                        </button>
                        <button
                            className={`section-btn ${viewMode === 'yearly' ? 'active' : ''}`}
                            onClick={() => setViewMode('yearly')}
                            style={{ minWidth: 'auto', minHeight: 'auto', padding: '10px 20px' }}
                        >
                            <span className="section-name">Annuel</span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="table-container-prof">
                <div className="table-title-prof">EVOLUTION DU CHIFFRE D'AFFAIRES ({viewMode.toUpperCase()})</div>
                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">PERIODE</th>
                            <th className="text-right">TOURISME</th>
                            <th className="text-right">BILLETTERIE</th>
                            <th className="text-right">TOTAL N</th>
                            <th className="text-right">TOTAL N-1</th>
                            <th className="text-right">VAR. (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {analysisData.map((row, index) => {
                            const variation = ((row.total - row.lastYear) / row.lastYear * 100).toFixed(1);
                            return (
                                <tr key={index}>
                                    <td className="text-left"><strong>{row.period}</strong></td>
                                    <td className="currency-cell">{priceFormatterV3(row.tourism)}</td>
                                    <td className="currency-cell">{priceFormatterV3(row.ticketing)}</td>
                                    <td className="currency-cell">{priceFormatterV3(row.total)}</td>
                                    <td className="currency-cell">{priceFormatterV3(row.lastYear)}</td>
                                    <td className={`percentage-cell ${parseFloat(variation) >= 0 ? 'text-success' : 'text-danger'}`}>
                                        {variation > 0 ? '+' : ''}{variation}%
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AnalyseTemporelle;
